function setToStorage(key, data) {
  if (!import.meta.client) return;

  if (!key) {
    console.error('Locale storage error: "Key is required"')
    return
  }

  data = typeof data === 'string' ? data : JSON.stringify(data)
  window.localStorage.removeItem(key)
  window.localStorage.setItem(key, data)
}

function getFromStorage(key) {
  if (!import.meta.client) return

  if (!key) {
    console.error('Locale storage error: "Key is required"')
    return
  }

  const data = window.localStorage.getItem(key)

  if (!data) {
    return null
  }

  try {
    return JSON.parse(data)
  }
  catch (error) {
    return data
  }
}

function removeFromStorage(key) {
  if (!import.meta.client) return

  if (!key) {
    console.error('Locale storage error: "Key is required"')
    return
  }

  window.localStorage.removeItem(key)
}

export function useStorage() {
  return { setToStorage, getFromStorage, removeFromStorage }
}